import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/authentication/Login.vue"),
  },
  {
    path: "/TwoFactorAuth",
    name: "Two Factor Auth",
    component: () => import("../views/authentication/TwoFactorAuth.vue"),
  },
  {
    path: "/createpassword",
    name: "CreatePassword",
    component: () => import("../views/authentication/CreatePassword.vue"),
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    redirect: "/home",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/CustomerList",
        name: "Send Transaction",
        component: () => import("../views/transaction/CustomerList.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/transaction/:stepCount?",
        name: "Transactions",
        component: () => import("../views/transaction/Transaction.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/transactionCalc",
        name: "Transactions",
        component: () => import("../components/Transactions/txnCalculator.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      //----------------- Routes for Customer manage---------------------------//
      {
        path: "/CustomerSummary",
        name: "Customer Summary",
        component: () =>
          import("../components/CustomerManager/CustomerSummary.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/CustomerMain",
        name: "Customer Main",
        component: () =>
          import("../components/CustomerManager/AddCustomer/CustomerMain.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/IndCustomer",
        name: "Customer Individual",
        component: () =>
          import("../components/CustomerManager/AddCustomer/IndCustomer.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/BusCustomer",
        name: "Customer Business",
        component: () =>
          import("../components/BusinessUserflow/CreateBusinessuser.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      //-------------------Beneficiary Summary pages-------------------------------//
      {
        path: "/BeneSummary",
        name: "Beneficiary Summary",
        component: () =>
          import(
            "../components/CustomerManager/BeneficiaryManage/BeneficiarySummary.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/CreateBene",
        name: "Beneficiary Summary",
        component: () =>
          import(
            "../components/CustomerManager/BeneficiaryManage/BeneficiarySummary.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      //--------------------------Transaction Details Routes------------------------------------------//
      {
        path: "/TransHoldpage",
        name: "Hold Transactions",
        component: () =>
          import("../components/Transactions/Transactionhold/TransHoldpage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/TransHoldDetails",
        name: "Hold Details",
        component: () =>
          import("../components/Transactions/Transactionhold/HoldTxnDetails.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/searchTxn",
        name: "Search Transactions",
        component: () =>
          import("../components/Transactions/SearchTransactons.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/txnDetails",
        name: "Dashboard Transactions",
        component: () =>
          import("../components/Transactions/DashboardTxns.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("fullpath", from.fullPath);
  const authenticatedUser = sessionStorage.getItem("access_token");
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  sessionStorage.setItem("prevPath", from.fullPath);
  // Check for protected route
  if (requiresAuth && !authenticatedUser) {
    next("/login");
  } else if (!requiresAuth && authenticatedUser) {
    next("/home");
  } else {
    next();
    console.log("route", to);
  }
});

export default router;
